import style from './style.module.css'

import ProfilePicture from '../../../../../../../assets/images/profile_picture.png'
import BookmarkIcon from '../../../../../../../assets/svgs/Bookmark'

const EventItem = () => {
  return (
    <div className={style.companyModal_events_item}>
      <div className={style.companyModal_events_item_photo}>
        <img src={ProfilePicture} alt="ProfilePicture" />
      </div>

      <div className={style.companyModal_events_item_text}>
        <span>
          <span>Meta recruiter</span> is having a seminar on 'How to Crack the
          Interview Process'
        </span>
      </div>

      <div className={style.companyModal_events_item_saveButton}>
        <BookmarkIcon />
      </div>
    </div>
  )
}

export default EventItem
